import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Button, Spinner } from 'react-bootstrap';
import ResultadosVotacion from './ResultadosVotacion';
import { useUserAdminStore } from '../stores/userAdmin';

const Estadisticas = () => {
    const [loading, setLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const { userAdmin } = useUserAdminStore();



    const handleLoadResults = () => {
        setLoading(true);
        setShowResults(false);
        setTimeout(() => {
            setLoading(false);
            setShowResults(true);
        }, 5000);
    };

    return (
        <>
            {userAdmin.login === false && <Navigate to="/iniciarsesionadmin" />}

            {userAdmin.login === true && (
                <>
                    <Container>
                        <div className="text-center my-4">
                            {!showResults &&
                                <h2 style={{marginTop:'50px', marginBottom:'30px'}}>Resultados del Presupuesto Participativo</h2>
                            }

                            <Button
                                variant="primary"
                                size="lg"
                                onClick={handleLoadResults}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" className="me-2" />
                                        Cargando resultados...
                                    </>
                                ) : 'Cargar Resultados'}
                            </Button>
                        </div>

                        {showResults && <ResultadosVotacion />}
                    </Container>
                    <div style={{ marginBottom: '200px' }} />
                </>
            )}
        </>
    );
};

export default Estadisticas;